<template>
<v-row justify="space-around" align="center">
    <v-col cols="7">
        <detail-growth-chart class="my-4" :chart-data="graphData" :height="400" />
    </v-col>

    <v-col>
        <v-data-table v-model="selected" :headers="headers" :items="items" item-key="name" dense hide-default-footer show-select>
        <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="item in items" :key="item.name">
                    <td>
                        <v-checkbox :input-value="visibility(item.name)" :color="itemColor(item)" style="margin:0px; padding:0px" hide-details @change="onCheckboxChanged(item, $event)" />
                    </td>
                    <td :style="`color: ${itemColor(item)}`">
                        <v-row>
                            <span>{{ item.name }}</span>
                        </v-row>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-data-table>
    </v-col>
</v-row>
</template>

<script>
import DetailGrowthChart from '@/views/charts/DetailGrowthChart'

var randomColor = require('randomcolor')

export default {
    name: 'asset-detail-report',
    props: [
        'value'
    ],
    components: {
        DetailGrowthChart,
    },
    data() {
        return {
            graphData: {},
            headers: [],
            items: [],
            selected: [],
        }
    },
    computed: {
        visibility() {
            return (name) => {
                return !this.graphData.datasets.find(x => x.label == name).hidden
            }
        }
    },
    mounted() {
        this.graphData = Object.assign({}, this.value)
        
        this.initHeaders()
        this.initItems()
        this.initSelected()
    },
    methods: {
        initItems() {
            this.items = []
            this.value.datasets.forEach(v => {
                this.items.push({
                    name: v.label
                })
            })
        },
        initHeaders() {
            this.headers = [{
                text: "종 목",
                value: "name",
                sortable: false
            }]
        },
        initSelected() {
            this.selected = this.items.slice()
        },
        onCheckboxChanged(item, value) {
            this.graphData.datasets.find(x => x.label == item.name).hidden = !value
            this.graphData = Object.assign({}, this.graphData)
            if (value) {
                this.selected.push(item)
            } else {
                this.selected.splice(this.selected.indexOf(item), 1)
            }
        },
        onSumChanged() {},
        itemColor(item) {
            return this.graphData.datasets.find(x => x.label == item.name).borderColor
        },
    }
}
</script>
